import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Subscription, SubscriptionsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsDataService {

  private uri: string = `${environment.apiUrl}subscriptions`;
  private cacheKey: string = 'subscriptions.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getSubscription(id: number): Observable<Subscription|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getSubscriptions(parameters: {[param: string]: string | string[]}): Observable<SubscriptionsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addSubscription(data: Subscription): Observable<Subscription|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addSubscriptions(data: Subscription[]): Observable<Subscription[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateSubscription(data: Subscription): Observable<Subscription|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateSubscriptions(data: Subscription[]): Observable<Subscription[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchSubscription(data: Subscription): Observable<Subscription|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchSubscriptions(data: Subscription[]): Observable<Subscription[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteSubscription(data: Subscription): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteSubscriptions(data: Subscription[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((subscription) => {
      ids.push(subscription.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
